// import Sass
import './style.scss';

// Countdown Time
document.addEventListener('DOMContentLoaded', () => {
	const allTextTyping = document.querySelectorAll('.wp-block-ttb-text-typing');
	Object.values(allTextTyping).map(textTyping => {
		const { typingContents, typeSpeed, startDelay, backSpeed, backDelay, isShuffle, isFadeOut, fadeOutDelay, isLoop, loopCount, isCursor, cursorChar } = JSON.parse(textTyping.dataset.typed);

		const options = {
			strings: typingContents.map(data => data.text), // array of strings
			stringsElement: null, // stringsElement ID of element containing string children
			typeSpeed,
			startDelay,
			backSpeed,
			backDelay,
			smartBackspace: false, // smartBackspace only backspace what doesn't match the previous string
			shuffle: isShuffle,
			fadeOut: isFadeOut, // fadeOut Fade out instead of backspace
			fadeOutClass: 'typed-fade-out', // fadeOutClass css class for fade animation
			fadeOutDelay,
			loop: isLoop,
			loopCount: 0 === loopCount ? Infinity : loopCount,
			showCursor: isCursor,
			cursorChar,
			autoInsertCss: false, // autoInsertCss insert CSS for cursor and fadeOut into HTML <head>
			attr: null, // attr attribute for typing. Ex: input placeholder, value, or just HTML text
			bindInputFocusEvents: false, // bindInputFocusEvents bind to focus and blur if el is text input
			contentType: 'html', // contentType 'html' or 'null' for plaintext
			preStringTyped: (pos, self) => {
				if (self && typingContents[self.sequence[pos]]) {
					self.el.style.color = typingContents[self.sequence[pos]].color || '#333';

					if (isCursor) {
						self.cursor.style.color = typingContents[self.sequence[pos]].color || '#333';
					}
				}
			}
		}

		new Typed(`#${textTyping.id} .ttbTextTyping .typingContents`, options);

		textTyping?.removeAttribute('data-typed');
	});
});